import { Feature, MultiPolygon, Polygon } from "../../util/turf";
import { proxy } from "valtio/vanilla";
import { Cluster } from "../../types/Cluster";

interface SiteProperties {
  _stage: string;
  color: string;
  title: string;
  hidden: boolean;
}

export interface SiteFeature extends Feature<Polygon | MultiPolygon> {
  properties: SiteProperties;
  id: string;
}

export type SiteGeometryStore = {
  siteFeatures: SiteFeature[];
  clusters: Cluster[];
  boundsDistance: number;
  activeRequestAbort?: AbortController["abort"];
};

export const getInitialSiteGeometryStore = (): SiteGeometryStore => ({
  siteFeatures: [],
  clusters: [],
  boundsDistance: 0,
});

export const siteGeometryStore = proxy<SiteGeometryStore>(getInitialSiteGeometryStore());
